import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { console_log, DataProvider } from 'src/providers/data/data';
import { CallapiService } from 'src/providers/rest/callapi.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-salecompany-apply-list',
  templateUrl: './salecompany-apply-list.component.html',
  styleUrls: ['./salecompany-apply-list.component.scss'],
})
export class SaleCompanyApplyListComponent implements OnInit {
  public csv1;
  public CompanyName = '';
  public Telephone = '';
  public check: boolean = false;
  public cancel_flg = '';
  public business_type = '';
  public BusinessType = [];
  public acquired_name = '';
  public AcquiredInfo;
  public acquired_data = '';
  public judge_state: string = '';
  
  public customCheckbox1;
  public customCheckbox2;
  public customCheckbox3;
  public customCheckbox4;
  public customCheckbox5;
  public customCheckbox6;
  public customCheckbox7;
  public judge_before = '';
  public judging = '';
  public re_judge_possible = '';
  public re_judge_waiting = '';
  public re_judging = '';
  public judge_ng = '';
  public user_auth_type;
  public user_auth_type_code;

  public management_company_name;
  public acquiredCheck: boolean = false;
  public documentpdf;
  filteredItems = [];
  business_code;
  pages: number;
  pageSize: number = 10;
  pageNumber: number = 0;
  currentIndex: number = 1;
  items = [];
  pagesIndex: Array<number>;
  pageStart: number = 1;
  constructor(
    private router: Router,
    public data: DataProvider,
    public rest: CallapiService,
    private spinner: NgxSpinnerService,
    protected datepipe: DatePipe,
  ) {
    this.BusinessType = [
      {code: "01", name: "農業・林業"},
      {code: "02", name: "漁業"},
      {code: "03", name: "鉱業，採石業，砂利，採取業"},
      {code: "04", name: "建設業"},
      {code: "05", name: "製造業"},
      {code: "06", name: "電気・ガス・熱供給・水道業"},
      {code: "07", name: "情報通信業"},
      {code: "08", name: "運輸業，郵便業"},
      {code: "09", name: "卸売業，小売業"},
      {code: "10", name: "金融業，保険業"},
      {code: "11", name: "不動産業，物品賃貸業"},
      {code: "12", name: "学術研究，専門・技術サービス業"},
      {code: "13", name: "宿泊業，飲食サービス業"},
      {code: "14", name: "生活関連サービス業，娯楽業"},
      {code: "15", name: "教育，学習支援業"},
      {code: "16", name: "医療，福祉"},
      {code: "17", name: "複合サービス事業"},
      {code: "18", name: "サービス業"},
      {code: "19", name: "公務"},
      {code: "20", name: "分類不能の産業"},
    ];
  }

  ngOnInit() {
    this.data.menuPageTitle = 'wf-salecompany-apply-list';
    if(this.check == true){
      this.cancel_flg = '1';
    }else{
      this.cancel_flg = ''
    }
    this.spinner.show();
    this.rest.Get_Screenauth(this.data.uuid).subscribe(
      (res) => {
        var pages = res.data;
        const page = pages.find(page => page.pagename === 'wf-salecompany-apply-list');
        var bool = page ? page.auth === "F" : false;
        if (!bool) {
          this.router.navigate(['/']);
        }
        this.rest.Get_AcquiredMaster(this.data.uuid).subscribe(
          (res) => {
            this.AcquiredInfo = res.data.AcquiredInfo;
            console_log(res);
          },
          (err) => {
            console_log(err);
          }
        );

        this.rest.Get_WFAccount(this.data.uuid).subscribe(
          (res) => {
            
            console_log(res);
            this.user_auth_type = res.data.user_auth_type;
            this.user_auth_type_code = res.data.user_auth_type_code;
            // this.management_company_name = res.data.management_company_name;
            if(this.user_auth_type_code == "wf-fc-head-limit" || this.user_auth_type_code == "wf-fc-head"){
              this.acquired_data = res.data.management_company_code + ':' +  res.data.management_company_name;
              console_log(this.user_auth_type_code);
              this.acquiredCheck = false; 
              this.Search();
            }  else {
              console_log(this.user_auth_type_code);
              this.acquiredCheck = true; 
              this.Search();
            }
        
            this.spinner.hide();
          },
          (err) => {
            console_log(err);
            this.spinner.hide();
            this.router.navigate(['/wf-contract-err', { code: err.error.error.code }]);
          }
        );
        // this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
   
    this.widthChanger('main-header', 360);
  }
  fillArray(): any {
    var obj = new Array();
    for (
      var index = this.pageStart;
      index < this.pageStart + this.pages;
      index++
    ) {
      obj.push(index);
    }
    return obj;
  }

  refreshItems() {
    this.items = this.filteredItems.slice(
      (this.currentIndex - 1) * this.pageSize,
      this.currentIndex * this.pageSize
    );
    this.pagesIndex = this.fillArray();
  }

  prevPage() {
    if (this.currentIndex > 1) {
      this.currentIndex--;
    }
    if (this.currentIndex < this.pageStart) {
      this.pageStart = this.currentIndex;
    }
    this.refreshItems();
  }

  nextPage() {
    if (this.currentIndex < this.pageNumber) {
      this.currentIndex++;
    }
    if (this.currentIndex >= this.pageStart + this.pages) {
      this.pageStart = this.currentIndex - this.pages + 1;
    }
    this.refreshItems();
  }

  setPage(index: number) {
    this.currentIndex = index;
    this.refreshItems();
  }

  selectedRadios(id) {
    this.pageSize = id;
    this.currentIndex = 1;
    this.pageStart = 1;
    this.pages = 6;

    this.pageNumber = parseInt('' + this.filteredItems.length / this.pageSize);
    if (this.filteredItems.length % this.pageSize != 0) {
      this.pageNumber++;
    }

    if (this.pageNumber < this.pages) {
      this.pages = this.pageNumber;
    }
    this.refreshItems();
  }

  widthChanger(className, width) {
    const headers = document.getElementsByClassName(className);
        for (let i = 0; i < headers.length; i++) {
          const header = headers[i] as HTMLElement;
          header.style.minWidth = width.toString() + 'px';
      }
  }
  
  Search() {
    this.spinner.show();
    this.business_code = this.business_type;
    if (this.customCheckbox1 == true) {
      this.judge_before = '1'
    } else {
      this.judge_before = ''
    }
    if (this.customCheckbox2 == true) {
      this.judging = '1'
    } else {
      this.judging = ''
    }
    if (this.customCheckbox3 == true) {
      this.re_judge_possible = '1'
    } else {
      this.re_judge_possible = ''
    }
    if (this.customCheckbox4 == true) {
      this.re_judge_waiting = '1'
    } else {
      this.re_judge_waiting = ''
    }
    if (this.customCheckbox5 == true) {
      this.re_judging = '1'
    } else {
      this.re_judging = ''
    }
    if (this.customCheckbox6 == true) {
      this.judge_ng = '1'
    } else {
      this.judge_ng = ''
    }

    for(let i = 0; i < this.BusinessType.length; i++){
      if(this.BusinessType[i].name == this.business_type){
        this.business_code =  this.BusinessType[i].code;
      }
    }
    // var acquired_name = this.acquired_data.split(":");
    // if(acquired_name[1] == undefined){
    //   acquired_name[1] = '';
    // }

    let acquired_name = '';
    if (this.acquired_data.includes(':')) {
      const parts = this.acquired_data.split(':');
      acquired_name = parts[1];
    } else {
      acquired_name = this.acquired_data;
    }
    this.rest.Get_ApplicationsSales(
      this.data.uuid,
      this.CompanyName,
      this.Telephone,
      acquired_name,
      this.judge_before,
      this.judging,
      this.re_judge_possible,
      this.re_judge_waiting,
      this.re_judging,
      this.judge_ng
      ).subscribe(
      (res) => {
        this.filteredItems = res.data.CorporationInfo;
        if (res.code == 'W000001') {
          document.getElementById('limit10000').style.display = 'block';
        } else {
          document.getElementById('limit10000').style.display = 'none';
        }
        this.currentIndex = 1;
        this.pageStart = 1;
        this.pages = 6;

        this.pageNumber = parseInt(
          '' + this.filteredItems.length / this.pageSize
        );
        if (this.filteredItems.length % this.pageSize != 0) {
          this.pageNumber++;
        }
        if (this.pageNumber < this.pages) {
          this.pages = this.pageNumber;
        }
        this.refreshItems();
        this.spinner.hide();
      },
      (err)=>{
        console_log(err);
        this.spinner.hide();
        this.router.navigate(['/wf-contract-err', {code: err.error.error.code}]);
      }
    );
  }

  details(uuid) {
    this.router.navigate(['/wf-salecompany-apply-detail', { uuid }]);
  }
  
  csvOutput(){
    const body = {
      app_date : "申請日",
      company_name : "会社名",
      business_type: "業種・業態",
      tel : "電話番号",
      mail_address : "メールアドレス",
      judge_state: '審査状態',
      acquired_name: "獲得企業名",
    }
    var csvItems = [];
    csvItems = this.filteredItems.map((_arrayElement) => Object.assign({}, _arrayElement));
    for(let i = 0; i < csvItems.length; i++){
      csvItems[i].business_type = this.getBusinessTypeLabel(csvItems[i].business_type);
    }
    for(let i = 0; i < csvItems.length; i++){
      if(csvItems[i].judge_state == '90'){
        csvItems[i].judge_state = '解約済'
      }else if(csvItems[i].judge_state == '90'){
        csvItems[i].judge_state = '契約中'
      }else if(csvItems[i].judge_state == '02'){
        csvItems[i].judge_state = '審査中'
      }else if(csvItems[i].judge_state == '03'){
        csvItems[i].judge_state = '再審査可能NG'
      }else if(csvItems[i].judge_state == '05'){
        csvItems[i].judge_state = '再審査中'
      }else if(csvItems[i].judge_state == '01'){
        csvItems[i].judge_state = '審査前'
      } else if (csvItems[i].judge_state == '04') {
        csvItems[i].judge_state = '再審査申請待ち'
      } else if (csvItems[i].judge_state == '99') {
        csvItems[i].judge_state = '審査NG'
      }
    }
    const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
    const header = Object.keys(body);
    const headerValue = Object.values(body);
    this.csv1= csvItems.map(row => header.map(fieldName =>
    JSON.stringify(row[fieldName], replacer)).join(','));
    this.csv1.unshift(headerValue.join(','));
    this.csv1 = this.csv1.join('\r\n');

    // Create link and download
    var download_name;
    download_name = '購入企業申し込み一覧.' + this.datepipe.transform(new Date(), 'yyyyMMddHHmmsss');
    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(this.csv1));
    link.setAttribute('download', download_name + '.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  formatBusinessType(businessType: number): string {
    return businessType < 10 ? `0${businessType}` : `${businessType}`;
  }

  getBusinessTypeLabel(businessType: string): string {
    const businessTypeMap: { [key: string]: string } = {
      '01': '農業・林業',
      '02': '漁業',
      '03': '鉱業，採石業，砂利，採取業',
      '04': '建設業',
      '05': '製造業',
      '06': '電気・ガス・熱供給・水道業',
      '07': '情報通信業',
      '08': '運輸業，郵便業',
      '09': '卸売業，小売業',
      '10': '金融業，保険業',
      '11': '不動産業，物品賃貸業',
      '12': '学術研究，専門・技術サービス業',
      '13': '宿泊業，飲食サービス業',
      '14': '生活関連サービス業，娯楽業',
      '15': '教育，学習支援業',
      '16': '医療，福祉',
      '17': '複合サービス事業',
      '18': 'サービス業',
      '19': '公務',
      '20': '分類不能の産業',
    };

    return businessTypeMap[this.formatBusinessType(parseInt(businessType))] || '';
  }

  Regist() {
    this.router.navigate(['/wf-salecompany-regist']);
  }
  pdf_download(uuid){
    this.rest
      .Download_Regcertificates(this.data.uuid,uuid)
      .subscribe((res) => {
        if (res.code == 'S000001') {
          this.documentpdf = res.data.s3url;
          window.open(this.documentpdf, '_blank', '');
        }
      },
      (err) => {
        console_log(err);
        this.spinner.hide();
        this.router.navigate(['/wf-contract-err', { code: err.error.error.code }]);
      }
      );
  }
}